export default __webpack_public_path__ + "static/media/700.769aff5c.woff2";